import markImage from "../../assets/brand/hazumu-mark.png";
import wordmarkImage from "../../assets/brand/hazumu-wordmark.png";

/*
 * The Hazumu wordmark: the "hazumu" logotype with its sun-and-smile mark.
 * Used wherever the brand appears so it always looks the same. The images are
 * imported so their URLs are content-hashed and a logo change is never served
 * from cache.
 */
const sizes = {
  sm: { wordmark: "h-5", mark: "size-6" },
  md: { wordmark: "h-7", mark: "size-8" },
  lg: { wordmark: "h-9", mark: "size-10" },
} as const;

export const Wordmark = ({
  size = "md",
  compact = false,
  className = "",
}: {
  size?: keyof typeof sizes;
  /** Shows only the mark on narrow phones. */
  compact?: boolean;
  className?: string;
}) => (
  <span className={`inline-flex shrink-0 items-center ${className}`}>
    <img
      src={wordmarkImage}
      alt="Hazumu"
      className={`w-auto shrink-0 ${sizes[size].wordmark} ${compact ? "max-sm:hidden" : ""}`}
    />
    {compact && (
      <img src={markImage} alt="Hazumu" className={`shrink-0 object-contain sm:hidden ${sizes[size].mark}`} />
    )}
  </span>
);
